export default "__VITE_ASSET__DUy1iT8m__"